import React, { useRef } from "react";
import { Col, Row } from "react-bootstrap";
import RGL, { WidthProvider } from "react-grid-layout";
import { useDispatch, useSelector } from "react-redux";
import Langs from "../../app/lang/langs";
import { getUserPreferences, isOwner, setUserPreferences } from "../../app/utils/helpers";
import addIcon from "../../assets/images/add.png";
import addIconFocus from "../../assets/images/addFocus.png";
import ImageButton from "../../components/buttons/ImageButton";
import { ShiftCell } from "../../components/scheduler/cells/shiftCell.js";
import { generateSampleShift } from "../../components/scheduler/shifts/sampleShiftsSlice";
import { setShowFormPopup } from "../planning/planningSlice";
import styles from "./Settings.module.css";

const ReactGridLayout = WidthProvider(RGL);

export default function ShiftTemplatesTab({ menuLabel }) {

  const dispatch = useDispatch()

  const sampleShiftsRef = useRef()

  const settings = useSelector((state) => state.settings)
  const userId = useSelector((state) => state.login.userId)
  const sampleShifts = useSelector((state) => state.sampleShifts.list)
  const userRoleId = useSelector((state) => state.login.userRoleId)

  const handleAddSampleShift = (event) => {
    let heureDebut = 9, heureFin = 17
    Object.values(settings.settingsList).map(item => {
      if (item.label === "Heure début de journée") heureDebut = item.settingValue
      if (item.label === "Heure fin de journée") heureFin = item.settingValue
    })
    dispatch(
      setShowFormPopup({
        type: "ADD_SAMPLE_SHIFT",
        data: generateSampleShift(heureDebut, heureFin),
      })
    )
  }

  function constructLayoutForSampleShifts() {
    let layout = []
    let shiftsArray = [].concat(sampleShifts)
    let shiftsUserOrder = getUserPreferences(userId, "SHIFTS_SAMPLES_ORDER")

    if (shiftsUserOrder) {
      shiftsArray = shiftsArray.sort((a, b) => {
        return shiftsUserOrder.indexOf(`${a["id"]}`) - shiftsUserOrder.indexOf(`${b["id"]}`)
      })
    }
    for (let i = 0; i < shiftsArray.length; i++) {
      let shift = shiftsArray[i]
      if (shift.id) {
        layout.push({
          i: shift["id"],
          x: i,
          y: 0,
          w: 1,
          h: 1,
          maxH: 1,
          minH: 1,
          data: shift,
        })
      }
    }
    return layout
  }

  const onLayoutChange = (layout) => {
    let newOrder = layout
      .sort((a, b) => a.y - b.y)
      .reduce((array, current) => {
        array.push(current["i"])
        return array
      }, [])
    setUserPreferences(userId, "SHIFTS_SAMPLES_ORDER", newOrder)
  }

  let sampleShiftsLayout = constructLayoutForSampleShifts()

  return (
    <Row className="m-0">
      <Col xxl={1}>
      </Col>
      <Col xxl={8} className="d-flex align-content-center">
        <div className={styles.menuContent}>
          <Row className="p-2">
            <Col
              xl={6}
              className="d-flex justify-content-start align-items-center p-2 ps-4">
              <label className={styles.menuHeaderTitle}>
                <Langs str={menuLabel} />
              </label>
            </Col>
            <Col
              xl={6}
              className="d-flex justify-content-end align-items-center p-2 pe-4">
              {isOwner(userRoleId) && <ImageButton
                onClick={handleAddSampleShift}
                image={addIcon}
                imageFocus={addIconFocus}
                active={true}
                width={32}
              />}
            </Col>
          </Row>
          <Row>
            <Col>
              <ReactGridLayout
                ref={sampleShiftsRef}
                layout={sampleShiftsLayout}
                onLayoutChange={onLayoutChange}
                items={sampleShiftsLayout.length}
                rowHeight={48}
                cols={1}
                isResizable={false}
                isDraggable={true}
                isBounded={true}>
                {sampleShiftsLayout.map((item) => {
                  return (
                    <div key={item["i"]}>
                      <ShiftCell
                        data={item.data}
                        isInteractive={true}
                        key={`ShiftCell_${item["i"]}`} />
                    </div>
                  )
                })}
              </ReactGridLayout>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  )
}
